import React, { useState } from 'react';
import * as styles from './commentsSectionDesktop.module.scss';
import { usePageContext } from '../context/pageContext';
import { SanityCommentsSection } from 'graphql-types';
import { GatsbyImage } from 'gatsby-plugin-image';
import { CTA } from '../html-tag/Cta';
import { Swiper } from 'swiper';
import { SwiperSlide } from 'swiper/react';
import { CommentsPagination } from '../commentsSlider/CommentsPagination';
import { graphql, useStaticQuery } from 'gatsby';
import { CommentsSliderDesktopPicture } from '../commentsSlider/CommentsSliderDesktopPicture';
import { CommentsSliderDesktop } from '../commentsSlider/CommentsSliderDesktop';
import 'swiper/css';
import { Blocks } from '../ui/blocks/Blocks';
import { findTranslation } from '../../utils/findTranslation';

interface Props {
  section: SanityCommentsSection;
}

export const CommentsSectionDesktop: React.FC<Props> = ({ section }) => {
  const { lang, defaultLang } = usePageContext();
  const [activeIndex, setActiveIndex] = useState<number>(0);
  const [swiperImage, setSwiperImage] = useState<Swiper | undefined>();
  const [swiper, setSwiper] = useState<Swiper | undefined>();

  swiperImage?.on('slideChange', (swiper) => {
    setActiveIndex(swiper.realIndex - 1);
  });

  const commentButton = useStaticQuery(COMMENTDESKTOP);
  return (
    <div className={styles.wrapper}>
      <h2>{findTranslation(section?._rawTitleSection, lang, defaultLang)}</h2>
      <div className={styles.button}>
        <CTA
          label={findTranslation(
            commentButton?.sanityFunctionButton?._rawTestinonials,
            lang,
            defaultLang,
          )}
          dataType={section?.colorNav ?? 'orange'}
          to={'/experience'}
          state={{ experienceId: section?.commentSectionRef?.id }}
        />
      </div>
      <div className={styles.slider}>
        <div className={styles.sliderPicture}>
          <div className={styles.pagination}>
            <CommentsPagination
              swiper={swiper}
              swiper2={swiperImage}
              color={section?.colorNav ?? ''}
              setActiveIndex={setActiveIndex}
              activeIndex={activeIndex}
              length={section?.commentsListSection?.length}
            />
          </div>

          <CommentsSliderDesktopPicture
            setSwiper={setSwiperImage}
            initialSlide={1}
            length={section?.commentsListSection?.length ?? 0}
          >
            {section?.commentsListSection?.map((comment, index) => {
              return (
                <SwiperSlide key={`comment-picture-${index}`}>
                  <div
                    id={`INDEX-${index}`}
                    className={`${styles.image} ${activeIndex + 1 === index && styles.active}`}
                  >
                    <GatsbyImage
                      alt={`comment-portrait-image`}
                      image={comment?.commentItemImg?.asset?.gatsbyImageData}
                    />
                  </div>
                </SwiperSlide>
              );
            })}
          </CommentsSliderDesktopPicture>
        </div>

        <CommentsSliderDesktop
          setThumbsSwiper={setSwiper}
          initialSlide={1}
        >
          {section?.commentsListSection?.map((comment, index) => {
            return (
              <SwiperSlide key={`comment-image-${index}`}>
                <div className={styles.comment}>
                  <div className={styles.quote}>
                    <Blocks
                      blocks={findTranslation(comment?._rawCommentItemText, lang, defaultLang)}
                    />
                  </div>
                  <div
                    className={styles.name}
                    data-type={section?.colorNav}
                  >
                    <h4>
                      <strong>{comment?.commentItemName}</strong>
                    </h4>
                  </div>
                  <div className={styles.subQuote}>
                    <Blocks
                      blocks={findTranslation(comment?._rawCommentItemSubtext, lang, defaultLang)}
                    />
                  </div>
                </div>
              </SwiperSlide>
            );
          })}
        </CommentsSliderDesktop>
      </div>
    </div>
  );
};

export const COMMENTDESKTOP = graphql`
  query CommentDesktop {
    sanityFunctionButton {
      _rawTestinonials(resolveReferences: { maxDepth: 10 })
    }
  }
`;
